var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Fragment',[(_vm.wrap)?_c('div',{staticClass:"flex border rounded-[3px]",class:[
			_vm.focused
				? 'border-color-main'
				: `${_vm.value === '' ? 'border-color-grey-light' : 'border-color-text'}`
		]},[_vm._t("default")],2):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }